
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22","cy":"22","r":"16","fill":"#F2F3F5"}}),_c('path',{attrs:{"d":"M18.836 18.694c.123.229.233.464.33.705M19.648 21.611c.014.26.014.519 0 .778M19.166 24.601c-.097.241-.207.476-.33.705","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"22","cy":"22","r":"7","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.164 25.306a6.94 6.94 0 01-.33-.704M24.352 22.389a7.056 7.056 0 010-.778M24.834 19.399c.097-.241.207-.476.33-.705","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    